import axios from 'axios';
import { toast } from 'react-toastify';

// Production
// https://glrious-website-backend.onrender.com

// https://glorious-backend-yz3j.onrender.com/api/v1
// http://localhost:7700/api/v1

export const Api_Url = 'https://glrious-website-backend.onrender.com';

// https://glorious-backend-yz3j.onrender.com/api/v1
// http://localhost:4300/api/v1

const APIs = axios.create({
  baseURL: `${Api_Url}/api/v1`,
  headers: {
    // Accept: 'application/json',
    // Authorization: `Bearer ${localStorage.getItem('token') ?? ''}`,
  },
});

APIs.interceptors.request.use(function (config) {
  if (navigator.onLine) {
    config.headers.Accept = 'application/json';
    const adminToken = localStorage.getItem('admin_token');
    const userToken = localStorage.getItem('token');

    config.headers.Authorization = `Bearer ${adminToken || userToken || ''}`;
    return config;
  } else {
    toast('No internet connection', {
      toastId: 'network error',
    });
  }
});

APIs.interceptors.response.use(
  (res) => res,
  (err) => {
    const isSilent = err.config?.silent; 

    if (!err.response) {
      if (!isSilent) {
        toast('Network Error: Unable to reach the server.');
      }

      return Promise.reject({
        message: 'Network Error: Unable to reach the server.',
      });
    }

    const errorData = err.response.data;

    // ✅ Only show toast if not marked silent
    if (!isSilent && errorData?.message) {
      toast(errorData.message);
    }

    return Promise.reject(errorData); // Let the calling function handle the error
  }
);


export default APIs;
